import React from 'react';

import Button from '../../UI/Button/Button';
import FlexModal from '../../UI/FlexModal/FlexModal';

import classes from './DownloadDialog.module.css';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import tickIconGreen from '../../../assets/icons/icon-success-dialog-green.png';

const dowloadDialog = (props) => {
    return(
        <FlexModal visible={props.show}>
            <div className={classes.VideoUploadSuccessDialog}>
                <img 
                    className={classes.CloseIcon}
                    src={closeIconBlack}
                    alt="Close Icon"
                    onClick={props.buttonClicked}
                />
                <img
                    className={classes.GreenTick}
                    alt="Tick Icon"
                    src={tickIconGreen} />
                <h3 className={classes.SuccessText}>Success</h3>
                <h4 className={classes.SuccessMessage}>{props.message}</h4>

                <div className={classes.UploadMoreButton}>
                    <a href={props.targetUrl} target="_blank" rel="noopener noreferrer" download>
                        <Button styleclass="NonMobileOnly" label={"Download"} margin="2em 0px 0px" fontSize="0.8em" />
                        <Button styleclass="MobileOnly" label={"Download"} margin="2em 0px 0px" fontSize="0.625em" />
                    </a>
                </div>
            </div>
        </FlexModal>
    );
}

export default dowloadDialog;